import { useEffect, memo } from 'react';
import dynamic from 'next/dynamic';
import { Loader, ProductCard } from '@/components';
import getProductWithoutQuantity from '@/lib/getProductWithoutQuantity';
import ecommerce from '@/seo/Ecommerce';

import styles from './Viewed.module.scss';

const RowSlider = dynamic(() => import('../../components/rowSlider'), {
	loading: () => <Loader />,
});

const Viewed = memo(({ products, currency, firstProductId, setFirstProductId }) => {
	useEffect(() => {
		if (
			Object.keys(currency).length > 0 &&
			products &&
			products.length &&
			firstProductId !== products[0]?.model?.id
		) {
			if (!!products[0]?.model?.id) {
				setFirstProductId(products[0].model.id);
			}
			ecommerce.viewItemList(
				getProductWithoutQuantity(products),
				currency,
				'Вы недавно просматривали',
			);
		}
	}, [currency, products, firstProductId]);

	const handleClickCard = (product, index) => {
		const newProducts = getProductWithoutQuantity([product]);

		ecommerce.viewItemList(newProducts, currency, 'Вы недавно просматривали', 'select_item', index);
	};

	return (
		<section className={styles.viewed}>
			<div className={styles.viewedTitle}>Вы недавно просматривали</div>

			<RowSlider arrowsOutside viewedProduct>
				{products.map((product, idx) => {
					return (
						<div
							key={product?.model?.id || idx}
							onClick={() => {
								handleClickCard(product, idx + 1);
							}}
						>
							<ProductCard
								{...product}
								mod='viewed'
								pageName={'Вы недавно просматривали'}
								indexCard={idx + 1}
							/>
						</div>
					);
				})}
			</RowSlider>
		</section>
	);
});

export default Viewed;
